import React from 'react';
import { IoAlertCircle, IoReload } from 'react-icons/io5';
//
import Botao from '../../components/Botao';
//
import styles from './erro.module.css';

interface ErroProps {
  /** Erro recebido do ErrorBoundary ou de uma falha no fluxo */
  error?: Error | null;
  /** Callback para tentar novamente — se ausente, mostra botão de recarregar página */
  onRetry?: () => void;
  /** Título customizado */
  title?: string;
  /** Mensagem customizada */
  message?: string;
}

export default function Erro({ error, onRetry, title, message }: ErroProps) {
  const handleRetry = () => {
    if (onRetry) {
      onRetry();
      return;
    }
    window.location.reload();
  };

  return (
    <div className={styles['container']}>
      <div className={styles['card']}>
        <div className={styles['icon-wrapper']}>
          <IoAlertCircle className={styles['icon']} />
        </div>

        <h1 className={styles['title']}>{title ?? 'Algo deu errado'}</h1>

        <p className={styles['message']}>
          {message ??
            'Encontramos um problema ao carregar esta página. Tente novamente em alguns instantes.'}
        </p>

        {error?.message && (
          <details className={styles['details']}>
            <summary>Detalhes técnicos</summary>
            <code className={styles['error-text']}>{error.message}</code>
          </details>
        )}

        <Botao
          icon={<IoReload />}
          text="Tentar novamente"
          onClick={handleRetry}
          color="primary"
          style={{ marginTop: '1rem' }}
        />
      </div>
    </div>
  );
}
